import React from "react";
import { AiOutlineAccountBook, AiOutlineHome } from "react-icons/ai";
import { BsChatLeftText } from "react-icons/bs";
import { PiVideoBold } from "react-icons/pi";
import { FiUser } from "react-icons/fi";
// import { HiOutlineUserGroup } from "react-icons/hi2";
import { MdOutlinePersonSearch, MdOutlineSell, MdOutlineSmartToy } from "react-icons/md";
import { ReactComponent as Elo } from "@/assets/svgs/elo.svg";
import { ReactComponent as AmericanExpress } from "@/assets/svgs/american-express.svg";
import { ReactComponent as Hipercard } from "@/assets/svgs/hipercard.svg";
import { ReactComponent as Mastercard } from "@/assets/svgs/mastercard.svg";
import { ReactComponent as Visa } from "@/assets/svgs/visa.svg";
import { rawPlanPrices } from "@/constants/plans";
export const navList = [
  {
    icon: React.createElement(AiOutlineHome),
    text: "Inicio",
    link: "/",
    svgSize: "1.3rem",
  },
  // {
  //   icon: React.createElement(AiOutlineAccountBook),
  //   text: "Cursos", 
  //   link: "/dashboard/",
  //   svgSize: "1.3rem",
  // },
  // {
  //   icon: React.createElement(MdOutlineChat),
  //   text: "Analise GPT",
  //   link: "chat",
  //   svgSize: "1.1rem",
  // },
  // Removido: item Afiliação
  // {
  //   icon: React.createElement(MdOutlineSmartToy),
  //   text: "Bilhetes Inteligentes",
  //   link: "smart-tickets",
  //   svgSize: "1.4rem",
  // },
  {
    icon: React.createElement(MdOutlinePersonSearch),
    text: "Buscar Jogadores",
    link: "jogadores",
    svgSize: "1.4rem",
  },
];

export const mobileNav = [
  ...navList,
  {
    icon: React.createElement(FiUser),
    text: "Perfil",
    link: "perfil",
    svgSize: "1.4rem",
  },
];

export const creditCardBrands = {
  visa: React.createElement(Visa),
  mastercard: React.createElement(Mastercard),
  hipercard: React.createElement(Hipercard),
  elo: React.createElement(Elo),
  "american-express": React.createElement(AmericanExpress),
};

const formatMoney = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

type PlanPrice = (typeof rawPlanPrices)[keyof typeof rawPlanPrices];

export const chooseInstallments = (quantity: number, planPrice: PlanPrice) => {

  // const resultado = (percentage / 100) * planPrice;
  const installmentsData = [
    { value: 1, label: `1x ${formatMoney.format(planPrice)}` },
    { value: 2, label: `2x ${formatMoney.format(planPrice / 2)}` },
    { value: 3, label: `3x ${formatMoney.format(planPrice / 3)}` },
    { value: 4, label: `4x ${formatMoney.format(planPrice / 4)}` },
    { value: 5, label: `5x ${formatMoney.format(planPrice / 5)}` },
    { value: 6, label: `6x ${formatMoney.format(planPrice / 6)}` },
    { value: 7, label: `7x ${formatMoney.format(planPrice / 7)}` },
    { value: 8, label: `8x ${formatMoney.format(planPrice / 8)}` },
    { value: 9, label: `9x ${formatMoney.format(planPrice / 9)}` },
    { value: 10, label: `10x ${formatMoney.format(planPrice / 10)}` },
    { value: 11, label: `11x ${formatMoney.format(planPrice / 11)}` },
    { value: 12, label: `12x ${formatMoney.format(planPrice / 12)}` },
  ];
  if (quantity >= 12) {
    return installmentsData;
  }
  return installmentsData.slice(0, quantity);
};
